import React from "react";

const Hero = () => (
	<section className="bg-gradient-to-br from-[#00BFFF] to-[#031B4E] text-white py-24 text-center">
		<h2 className="text-5xl font-bold mb-4">Empowering Digital Connectivity</h2>
		<p className="text-lg mb-6">
			Your trusted partner in telecom and ICT infrastructure solutions.
		</p>
		<a
			href="#contact"
			className="bg-white text-[#031B4E] px-6 py-3 rounded font-semibold hover:bg-gray-200"
		>
			Get Connected
		</a>
	</section>
);

export default Hero;
